import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Typography, { TYPOGRAPHY_TITLE } from 'common/components/typography';
import event from '~helpers/mixpanel';
import Broadcast from './broadcast';
import HerculesOperationsPage from './operations';
import classNames from 'classnames';

const useStyles = makeStyles(() => ({
  dashboardWrapper: {
    padding: '40px 24px 74px',
    height: '100%',
  },
  row: {
    display: 'flex',
  },
  title: {
    margin: '0 0 32px',
    marginBottom: '32px !important',
  },
}));

const Dashboard = ({ landlord }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const history = useHistory();
  const { location } = history;

  const { hasTotalOrders, hasManualBookings } = useSelector(state => ({
    hasTotalOrders: state.auth.getIn(['properties', 'hasTotalOrders']),
    hasManualBookings: state.auth.getIn(['properties', 'hasManualBookings']),
  }));

  useEffect(() => {
    event('Viewed Dashboard Page');
    event('Viewed News Feed Page');
  }, []);

  return (
    <div className={classNames(classes.dashboardWrapper, 'dashboard-wrapper')}>
      <Typography
        textType={TYPOGRAPHY_TITLE}
        className={classes.title}
        fontSize={30}
        lineHeight={38}
      >
        {t('landlord.new_dashboard.title', {
          name: landlord?.firstName,
        })}
      </Typography>
      {/* DON'T NEED NOW, WILL SHOW IN THE FUTURE */}
      {/* <TopBanner t={t} /> */}
      <div className={classes.row}>
        <HerculesOperationsPage landlord={landlord} />
        <Broadcast landlord={landlord} t={t} />
      </div>
    </div>
  );
};

Dashboard.propTypes = {
  landlord: PropTypes.object,
};

export default Dashboard;
